var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsEditFilled2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C1DE",
    d: "M14.794 6.208l2.998 2.998L6.74 20.252 3 21l.748-3.74L14.794 6.207zm2.292-2.293a1.998 1.998 0 012.828 0l.172.17a2 2 0 010 2.829l-.88.878-2.998-2.999.878-.878z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCAwSDI0VjI0SDB6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTI3NiAtMTc5MikgdHJhbnNsYXRlKDExOTggMTc4MCkgdHJhbnNsYXRlKDc4IDEyKSIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiMwMEMxREUiIGQ9Ik0xNC43OTQgNi4yMDhsMi45OTggMi45OThMNi43NCAyMC4yNTIgMyAyMWwuNzQ4LTMuNzRMMTQuNzk0IDYuMjA3em0yLjI5Mi0yLjI5M2MuNzgxLS43ODIgMi4wNDgtLjc4MiAyLjgyOCAwbC4xNzIuMTdjLjc4MS43ODIuNzgxIDIuMDQ4IDAgMi44MjlsLS44OC44NzgtMi45OTgtMi45OTkuODc4LS44Nzh6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTI3NiAtMTc5MikgdHJhbnNsYXRlKDExOTggMTc4MCkgdHJhbnNsYXRlKDc4IDEyKSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgIconsEditFilled2 as ReactComponent };